// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__18Mpv","description":"PatientConsentPreview_description__1w1ZI"};